var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"105",
      name:"维护按钮",
      parentId:"OP_ID,DATA_CLASS",
      parentName:"数据定义",
      parentPath:"/system/functionSon",
      parentQuery:{
        OP_ID:_vm.$route.query.OP_ID,
        sname:_vm.$route.query.pname,
      },
      addForm:{
        OP_ID:_vm.$route.query.OP_ID,
        DATA_CLASS:_vm.$route.query.sname,
      },
      dataClass:11,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }